import React, { useState } from "react";
import AdminSubscriptionsList from "./AdminSubscriptionsList";
import AdminPaymentHistory from "./AdminPaymentHistory";
import AdminRevenueAnalytics from "./AdminRevenueAnalytics";

export default function AdminSubscriptionPanel() {
  const [activeTab, setActiveTab] = useState("subscriptions"); // subscriptions, payments, analytics

  const tabs = [
    {
      id: "subscriptions",
      label: "💳 Subscriptions",
      icon: "⭐",
      description: "Manage premium subscriptions",
    },
    {
      id: "payments",
      label: "💰 Payment History",
      icon: "💸",
      description: "View all payments and transactions",
    },
    {
      id: "analytics",
      label: "📊 Revenue Analytics",
      icon: "📈",
      description: "Revenue metrics and trends",
    },
  ];

  return (
    <div className="w-full">
      {/* Header */}
      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white p-8 rounded-lg mb-6">
        <h1 className="text-4xl font-bold mb-2">Premium Subscriptions Admin</h1>
        <p className="text-indigo-100">Manage premium features, track revenue, and monitor subscriptions</p>
      </div>

      {/* Tabs */}
      <div className="flex flex-wrap gap-2 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition ${
              activeTab === tab.id
                ? "bg-indigo-600 text-white shadow-lg"
                : "bg-white dark:bg-gray-700 text-gray-800 dark:text-white border border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600"
            }`}
          >
            <span className="text-xl">{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6">
        {activeTab === "subscriptions" && (
          <div>
            <div className="mb-6">
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">Premium Subscriptions</h2>
              <p className="text-gray-600 dark:text-gray-400">
                View and manage all user subscriptions, expiry dates, and plans
              </p>
            </div>
            <AdminSubscriptionsList />
          </div>
        )}

        {activeTab === "payments" && (
          <div>
            <div className="mb-6">
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">Payment History</h2>
              <p className="text-gray-600 dark:text-gray-400">
                Complete transaction history with status, plans, and payment methods
              </p>
            </div>
            <AdminPaymentHistory />
          </div>
        )}

        {activeTab === "analytics" && (
          <div>
            <div className="mb-6">
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">Revenue Analytics</h2>
              <p className="text-gray-600 dark:text-gray-400">
                Revenue metrics, trends, and business insights
              </p>
            </div>
            <AdminRevenueAnalytics />
          </div>
        )}
      </div>

      {/* Footer Info */}
      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
        <p className="text-sm text-blue-900 dark:text-blue-200">
          <strong>💡 Tip:</strong> All data shown here is real-time from Firestore. Use the filters to search, sort, and analyze subscription data. Revenue calculations only include successful payments.
        </p>
      </div>
    </div>
  );
}
